import type { ReactNode } from 'react';

interface ProfileRowProps {
  label: string;
  value: ReactNode;
  action?: ReactNode;
  /** What opens under the row: an inline edit, a change panel. */
  children?: ReactNode;
}

/** One line of the Profile card: label, value, and the action that changes it. Below `sm` the label sits above the value. */
export function ProfileRow({ label, value, action, children }: ProfileRowProps) {
  return (
    <div className="px-5 py-4">
      <div className="grid grid-cols-[1fr_auto] items-center gap-x-4 gap-y-1 sm:grid-cols-[8rem_1fr_auto]">
        <dt className="col-span-2 text-sm text-muted sm:col-span-1">{label}</dt>
        <dd className="min-w-0 text-sm break-words text-fg">{value}</dd>
        {action && <div className="justify-self-end">{action}</div>}
      </div>
      {children}
    </div>
  );
}
